import type { ShellHydration } from './hydration.js';

interface GraphQLRequest {
  query: string;
  variables?: Record<string, unknown>;
  operationName?: string;
}

interface GraphQLResponse<T> {
  data?: T;
  errors?: Array<{ message?: string }>;
}

export async function graphqlRequest<TResult>(
  hydration: ShellHydration,
  request: GraphQLRequest,
): Promise<GraphQLResponse<TResult>> {
  const headers: Record<string, string> = { 'content-type': 'application/json' };
  // Public SDK mutations (trackAnnouncementEvent, trackSurveyEvent, etc.) gate
  // on this header to resolve the project from the client_id. Without it,
  // every mutation throws "missing client identifier" and analytics counters
  // never increment.
  if (hydration.clientId) headers['x-chirp-client-id'] = hydration.clientId;

  const response = await fetch(`${hydration.apiHost}/api/graphql`, {
    method: 'POST',
    headers,
    body: JSON.stringify(request),
  });
  return (await response.json()) as GraphQLResponse<TResult>;
}

export function throwIfGraphQLError<T>(response: GraphQLResponse<T>, fallback: string): void {
  if (!response.errors?.length) return;
  throw new Error(response.errors[0]?.message ?? fallback);
}
